export const FRANCHISE_REGIONS = [
  { value: 'HQ', label: 'Headquarters' },
  { value: 'north_york', label: 'North York' },
  { value: 'london', label: 'London' },
  { value: 'toronto', label: 'Toronto' },
  { value: 'hamilton', label: 'Hamilton' },
  { value: 'mississauga', label: 'Mississauga' },
  { value: 'brampton', label: 'Brampton' },
  { value: 'scarborough', label: 'Scarborough' },
  { value: 'general', label: 'General' }
] as const;

export type FranchiseRegionValue = typeof FRANCHISE_REGIONS[number]['value'];

